module.exports = __webpack_public_path__ + "images/file_icons_v2/png-d31646d69212851c2068e4f1c774f4d9.svg";